<template>
  <v-btn
    :color="pressed ? 'secondary' : ''"
    :block="block"
    :large="large"
    :flat="flat"
    @click="$emit('click')"
  >
    <v-icon
      v-if="showUnpressed && !pressed"
      class="absolute-right"
      color="error"
    >
      close
    </v-icon>
    <slot/>
    <v-icon
      v-if="pressed"
      class="absolute-right"
      color="green"
    >
      check
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'PressableButton',

  props: {
    showUnpressed: {
      type: Boolean,
      default: false
    },
    pressed: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    }
  }
}
</script>
